<template>

<div class="links">

	<router-link :to="{path: '/' + link.url}" class="links-item" v-for="(link, index) in data.links" :key="index">{{ link.name }}</router-link>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.links {
	flex-grow: 1;
	flex-basis: 0;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	min-height: 40px;
	align-items: center;
}

.is-tablet .links {
    margin-bottom: 20px;
}

.is-mobile .links {
    justify-content: center;
    margin-bottom: 20px;
    min-height: auto;
}

.links-item {
	font-size: 12px;
	line-height: 20px;
	color: #fff;
	margin-right: 20px;
}

.is-desktop .links-item:hover {
	text-decoration: underline;
}

</style>